const TOC_PINNED_STORAGE_KEY_PREFIX = 'nb:toc-pinned:';

export function getTocPinnedStorageKey(documentId: string): string {
  return `${TOC_PINNED_STORAGE_KEY_PREFIX}${documentId}`;
}

function canPersistForDocument(documentId: string | null | undefined): documentId is string {
  return typeof documentId === 'string' && documentId.length > 0 && documentId !== 'new';
}

export function readTocPinned(documentId: string | null | undefined): boolean {
  if (!canPersistForDocument(documentId) || typeof localStorage === 'undefined') {
    return false;
  }

  try {
    return localStorage.getItem(getTocPinnedStorageKey(documentId)) === 'true';
  } catch {
    return false;
  }
}

export function writeTocPinned(documentId: string | null | undefined, pinned: boolean): void {
  if (!canPersistForDocument(documentId) || typeof localStorage === 'undefined') {
    return;
  }

  try {
    const key = getTocPinnedStorageKey(documentId);
    if (pinned) {
      localStorage.setItem(key, 'true');
    } else {
      localStorage.removeItem(key);
    }
  } catch {
  }
}
